import { StorageKeys } from '../../../../lib/constants/storageKeys';
import { localStorageUtils } from '../../../../lib/utils/storage/storageUtils';

export const clearNotificationsData = () => {
  localStorageUtils.remove([StorageKeys.LOGIN_NOTIFICATIONS]);
};

export const getNotificationState = () => localStorageUtils.get(StorageKeys.LOGIN_NOTIFICATIONS) ?? '';

export const storeNotificationState = (hashedState: string) => {
  localStorageUtils.save(StorageKeys.LOGIN_NOTIFICATIONS, hashedState);
};
